import { hexToRGB } from '@repo-level/core-front';
import { device } from 'components/styles/MediaQuery';
import styled, { css } from 'styled-components/macro';

export const ScModal = styled.div`
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: fixed;
  outline: 0 !important;
  overflow: hidden auto;
  z-index: 1111;

  @media (${device.mobile}) {
    left: 0 !important;
  }

  & > .bg {
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: -1;
    overflow: hidden;
    position: fixed;
    background: ${({ theme }) => hexToRGB(theme.blackColor, 0.84)};

    backdrop-filter: ${({ theme }) => theme.secondaryBackdropFilter2};

    @media (${device.mobile}) {
      left: 0 !important;
    }
  }

  & > .container {
    position: absolute;
    width: 100%;
    min-height: 100%;
    left: 0;
    top: 0;
    box-sizing: border-box;
    overflow-y: hidden auto;
    -webkit-overflow-scrolling: touch;

    @media (${device.mobile}) {
      padding: 0;
    }
  }
`;

export const ScDefModalContent = styled.div`
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.3) -5.56%,
    rgba(255, 255, 255, 0.1) 105.56%
  );
  position: relative;
  border-radius: 4px;
  z-index: 1;
  padding: 32px 16px 32px;
  &:after {
    position: absolute;
    content: '';
    left: 2px;
    top: 2px;
    right: 2px;
    bottom: 2px;
    background: ${({ theme }) => hexToRGB(theme.secondaryColor4)};
    border-radius: 4px;
    z-index: -1;
  }
`;

interface ScModalHeadlineProps {
  isMobile: boolean;
}
export const ScModalHeadline = styled.div<ScModalHeadlineProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ isMobile }) =>
    isMobile &&
    css`
      width: 100%;
      justify-content: space-between;
      button {
        position: relative;
        top: auto;
        right: auto;
      }
    `}
`;
